<template>
  <views class="processes-statistics">
    <ViewsTabs
      :tabs="[]">
      <template #content>
        <div class="flex justify-between items-center w-full">
          <h1 class="mr-auto w-full text-xl font-bold">{{ $t('generics.global-statistics') }}</h1>
          <dashboard-modules-filters module-name="activity"></dashboard-modules-filters>
        </div>
      </template>
    </ViewsTabs>
    <views-container>
      <div class="processes-statistics__container">
        <div class="processes-statistics__clients">
          <statistics-candidates style="width: fit-content;"></statistics-candidates>
          <statistics-companies></statistics-companies>
        </div>
        <statistics-processes></statistics-processes>
        <statistics-jobboards></statistics-jobboards>
      </div>
    </views-container>
    <router-view></router-view>
  </views>
</template>

<script>
import Views from '@/components/Views/Views';
import ViewsContainer from '@/components/Views/ViewsContainer';
import DashboardModulesFilters from '@/components/Dashboard/DashboardModules/DashboardModulesFilters';
import StatisticsCandidates from '@/components/Statistics/StatisticsCandidates';
import StatisticsCompanies from '@/components/Statistics/StatisticsCompanies';
import StatisticsProcesses from '@/components/Statistics/StatisticsProcesses';
import StatisticsJobboards from '@/components/Statistics/StatisticsJobboards';
import { mapStores } from 'pinia';
import { useStatisticsStore } from '@/store/pinia/statistics';
import { mapState } from 'vuex';
import { startOfWeek, endOfWeek, format } from 'date-fns';
import ViewsTabs from '@/components/Views/ViewsTabs.vue';

export default {
  name: 'processes-statistics',
  components: {
    Views,
    ViewsContainer,
    DashboardModulesFilters,
    StatisticsCandidates,
    StatisticsCompanies,
    StatisticsProcesses,
    StatisticsJobboards,
    ViewsTabs,
  },
  computed: {
    ...mapState({
      organizationId: (state) => state.user?.profile?._organization?._id,
    }),
    ...mapStores(useStatisticsStore),
  },
  created() {
    // if was loading, we need to set the loading to false
    if (this.statisticsStore.processes.isLoading) {
      this.statisticsStore.setAllLoading(false);
    }

    if (!this.statisticsStore.fetchedAt || this.statisticsStore.organizationId !== this.organizationId) {
      this.statisticsStore.setOrganizationId(this.organizationId);
      this.statisticsStore.getStatistics({
        period: this.$route.query[`${this.moduleName}Period`] || 'week',
        startDate: this.$route.query[`${this.moduleName}Start`] || format(startOfWeek(new Date()), 'dd-MM-yyyy'),
        endDate: this.$route.query[`${this.moduleName}End`] || format(endOfWeek(new Date()), 'dd-MM-yyyy'),
      });
    }
  },
};
</script>

<style lang="scss" scoped>
.processes-statistics {
  &:deep(.views-tab__content) {
    @apply w-full;
  }

  &__container {
    flex-direction: column;
    gap: 36px;
  }

  &__clients {
    gap: 20px;
  }
}
</style>
